export default { audioInputSplicer: 'audio-input-splicer' };
